var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductsBrunoApiBenefits2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2708_7685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.9968 21.984L52.6473 16.3523L47.0156 5.0029C53.3696 1.91987 60.3492 0.220746 68.9997 0C68.7789 8.65061 67.0798 15.6301 63.9968 21.984Z",
    fill: "#ED041D",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9969 21.984C67.0799 15.6301 68.779 8.65061 68.9998 0L52.6475 16.3523L63.9969 21.984Z",
    fill: "#ED041D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0541 29.2168L11.1953 26.358L26.3004 11.2529L39.8504 14.6603L37.7928 17.1311C34.5878 20.9726 31.4526 26.3246 29.1871 31.8175L28.0298 34.6163L22.6304 29.2169C20.2658 26.8522 16.4187 26.8522 14.0541 29.2168Z",
    fill: "#ED041D",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.642 57.8046L39.7832 54.9458C42.1478 52.5812 42.1478 48.7341 39.7832 46.3694L34.3838 40.97L37.1826 39.8127C42.6755 37.5472 48.0273 34.412 51.869 31.207L54.3398 29.1494L57.7472 42.6994L42.642 57.8046Z",
    fill: "#ED041D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9974 21.9841L47.0162 5.00293C43.4999 6.68952 39.9835 9.0052 36.9246 12.0641C32.1876 16.8011 27.9842 24.0437 25.4608 30.2747C22.6455 36.948 22.5853 39.9138 22.459 40.4807L28.5197 46.5413C29.0582 46.4214 32.0589 46.3521 38.7256 43.5396C44.888 41.0438 52.1332 36.8788 56.9362 32.0757C59.9951 29.0168 62.3108 25.5004 63.9974 21.9841Z",
    fill: "#F9F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 68.9997C1.47191 64.4972 7.49283 47.2129 11.195 43.5107C15.1357 39.57 21.547 39.5687 25.489 43.5107C29.4311 47.4527 29.4297 53.8641 25.489 57.8048C21.783 61.5109 4.10833 67.6568 0 68.9997Z",
    fill: "#FFC165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5067 13.4932L25.4893 43.5106L28.5196 46.5409C29.0583 46.4211 32.0587 46.3516 38.7255 43.5392C44.888 41.0434 52.1332 36.8782 56.9361 32.0753C59.9951 29.0164 62.3107 25.5 63.9973 21.9837L55.5067 13.4932Z",
    fill: "#D9C4AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.489 57.8048C29.4297 53.8641 29.4311 47.4528 25.489 43.5107L0 68.9998C4.10833 67.6567 21.783 61.5108 25.489 57.8048Z",
    fill: "#DD9326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6416 26.3578C40.277 23.9932 40.277 20.146 42.6416 17.7813C45.0062 15.4166 48.8534 15.4167 51.2181 17.7813C53.5827 20.1459 53.5827 23.9931 51.2181 26.3578C48.8534 28.7225 45.0062 28.7225 42.6416 26.3578Z",
    fill: "#66CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2181 26.3577C53.5827 23.9931 53.5827 20.146 51.2181 17.7812L42.6416 26.3577C45.0062 28.7225 48.8534 28.7225 51.2181 26.3577Z",
    fill: "#59ABFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2708_7685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 69,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsBrunoApiBenefits2);
export default __webpack_public_path__ + "static/media/products_bruno_api_benefits_2.a073e7a745782a1bde7340a619de6f27.svg";
export { ForwardRef as ReactComponent };